<template>
  <div class="section">
    <h1>title</h1>

  </div>
</template>

<script>
export default {
  name: 'adpSection',
  props: {
  }
}
</script>

<style scoped>
.section {
    min-height: 100vh;
}
</style>
